import script from "./YunusRajabiy.vue?vue&type=script&setup=true&lang=js"
export * from "./YunusRajabiy.vue?vue&type=script&setup=true&lang=js"

import "./YunusRajabiy.vue?vue&type=style&index=0&id=e42cbc80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e42cbc80"]])

export default __exports__